<template>
  <div class="container">
    <div class="iframeBox">
      <iframe
        :src="modLink"
        frameborder="0"
        width="100%"
        height="100%"
        ref="iframe"
        id="iframe"
      ></iframe>
    </div>

    <div class="informationBox">
      <div
        class="fold"
        :class="{ rotate: showInfo }"
        @click="showInfo = !showInfo"
      >
        <img src="../../image/fold.png" alt="" />
      </div>
      <div class="baseInfoBox" v-show="showInfo">
        <div class="title"></div>
        <div class="modName">
          <span v-html="modName"></span>
        </div>
        <div class="modtext">
          <span v-html="modString"></span>
        </div>
      </div>
      <div class="CollectionInfoBOx" v-show="showInfo">
        <div class="title"></div>
        <div class="textInfo" v-html="modInfo"></div>
      </div>
    </div>
    <div
      class="musicIcon"
      :class="[
        musicSelect ? 'musicIcon_open' : 'musicIcon_close',
        isShow ? 'disShow' : 'dis',
      ]"
      @click="changeMusicState"
    ></div>
    <!-- <div class="VRIcon"></div> -->
    <audio :src="modMp3" ref="audio" id="audio" loop autoplay></audio>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: [],
  data() {
    return {
      modLink: "",
      musicSelect: true,
      modName: "",
      modString: "",
      modInfo: "",
      modMp3: "",
      showInfo: true,
      isShow: false,
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    let mid = this.getQueryString("id");
    if (mid != undefined) {
      this.$http
        .get("https://nybwg.11dom.com/h5/model_list/" + mid + "/info")
        .then((res) => {
          this.modLink = res.data.data.modLink;
          this.modName = res.data.data.modName;
          this.modString = res.data.data.modString;
          this.modInfo = res.data.data.modInfo;
          this.modMp3 = res.data.data.modMp3;
        });
    }
    var that = this;
    const iframe = document.querySelector("#iframe");
    if (iframe.attachEvent) {
      iframe.attachEvent("onload", function () {
        that.isShow = true;
      });
    } else {
      iframe.onload = function () {
        that.isShow = true;
      };
    }
    this.weixin_environment();
  },
  methods: {
    changeMusicState() {
      if (this.$refs["audio"].paused) {
        this.$refs["audio"].play();
        this.musicSelect = true;
      } else {
        this.$refs["audio"].pause();
        this.musicSelect = false;
      }
    },
    getPathID() {
      return this.$route.query.id;
    },
    getQueryString(name) {
      var url = window.location.href;
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = url.split("?")[1].match(reg);
      if (r != null) {
        return r[2];
      }
      return "";
    },
    weixin_environment() {
      var UA = navigator.userAgent.toLowerCase();
      if (UA.match(/MicroMessenger/i) == "micromessenger") {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            document.getElementsByClassName(
              "informationBox"
            )[0].style.fontSize = "0.85rem";
          }
        });
      } else {
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.container {
  height: 100vh;
  .informationBox {
    position: absolute;
    bottom: 2rem;
    right: 3rem;
    max-width: 25vw;
    padding: 10px;
    color: rgb(253, 253, 253);
    font-weight: bold;
    transition: width 0.3s;

    .baseInfoBox {
      .title {
        width: 8vw;
        height: 4vh;
        background-image: url(../../image/base.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-bottom: 10px;
      }
    }
    .CollectionInfoBOx {
      margin-top: 10px;
      .title {
        width: 8vw;
        height: 4vh;
        background-image: url(../../image/Collection.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-bottom: 10px;
      }
    }
  }
  .VRIcon {
    width: 10vw;
    height: 10vh;
    background-image: url(../../image/VRIcon.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    bottom: 5rem;
    right: 5rem;
  }
  .musicIcon {
    position: absolute;
    top: 4rem;
    right: 0.6rem;
    width: 42px;
    height: 42px;
    background-color: #978d82;
    border-radius: 50%;
    background-position: center center;
    cursor: pointer;
  }
  .musicIcon_open {
    background-image: url(../../image/icon-music.png);
    background-repeat: no-repeat;
    background-size: 50% 50%;
  }
  .musicIcon_close {
    background-image: url(../../image/icon-music-no.png);
    background-repeat: no-repeat;
    background-size: 50% 50%;
  }
  .fold {
    // position: absolute;
    // top: 2rem;
    // right: 5rem;
    width: 30px;
    height: 30px;
    display: none;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #978d82;
    transition: all 0.3s;
    margin-bottom: 10px;
    img {
      width: 18px;
    }
  }
  .rotate {
    transform: rotate(180deg);
  }
}
.iframeBox {
  height: 100%;
}

.dis {
  display: none;
}
.disShow {
  display: block;
}

@media (max-width: 600px) {
  .container {
    .title {
      width: 100px !important;
    }
    .informationBox {
      right: 0;
      bottom: 0;
      max-width: 100vw;
      box-sizing: border-box;
      width: 100%;
    }
    .musicIcon {
      right: 5px;
      top: 44px;
      width: 26px;
      height: 26px;
    }
    .fold {
      display: flex;
    }
  }
}
</style>

